<section class="rounded-xl border border-slate-200 bg-white shadow-sm">
  @if (!bare()) {
    <header class="border-b border-slate-200 px-6 py-5">
      <h2 class="text-base font-bold text-slate-900">{{ heading() }}</h2>
      @if (description()) {
        <p class="mt-1 text-sm text-slate-500">{{ description() }}</p>
      }
    </header>
  }

  <div class="px-6 py-6">
    <ng-content />
  </div>
</section>
